export default __webpack_public_path__ + "static/media/logo.8a2a52ed.png";